module.exports = __webpack_public_path__ + "static/media/NotFoundPic.953dd785.png";